import { ChevronRightIcon } from '@heroicons/react/24/outline';

import { ALL_SYSTEMS } from '../state';
import { TKSystem, CATALOGUE_CATEGORY as CAT } from '../types';

/**
 * multiple level system
 * @date 2025/03/04
 */
export const MultiLevelSystem = ({
  systems,
  customSystems,
  handleSystemFilter,
}: {
  systems: TKSystem[];
  customSystems: string[];
  handleSystemFilter: (system: string) => void;
}) => {
  const ductSystems = systems.filter((sys) => sys.category === CAT.D);
  const pipeSystems = systems.filter((sys) => sys.category === CAT.P);
  return (
    <ul className="mls nested-menu-dropdown dropdown-menu w-28">
      <li className="dropdown-menu-item">
        <button
          type="button"
          className="text-left w-full focus:outline-none flex justify-between"
          onClick={() => handleSystemFilter('*')}
        >
          {ALL_SYSTEMS.label}
        </button>
      </li>
      {/* == Project level systems == */}
      <li className="dropdown-menu-item">
        <button
          type="button"
          className="text-left w-full focus:outline-none flex justify-between"
        >
          Custom
          <ChevronRightIcon className="size-4 inline-block" />
        </button>
        {/* sub menu system list */}
        <ul className="dropdown-submenu dropdown-menu w-48">
          {customSystems.map((sys) => (
            <li key={sys} className="dropdown-menu-item" data-item={sys}>
              <button
                type="button"
                className="text-left w-full focus:outline-none"
                onClick={() => handleSystemFilter(sys)}
              >
                {sys}
              </button>
            </li>
          ))}
        </ul>
      </li>
      {/* == DUCT category systems == */}
      <li className="dropdown-menu-item">
        <button
          type="button"
          className="text-left w-full focus:outline-none flex justify-between"
        >
          Duct
          <ChevronRightIcon className="size-4 inline-block" />
        </button>
        {/* sub menu system list */}
        <ul className="dropdown-submenu dropdown-menu w-48">
          {ductSystems.map((dsys) => (
            <li
              key={dsys.short}
              className="dropdown-menu-item"
              data-item={dsys.short}
            >
              <button
                type="button"
                className="text-left w-full focus:outline-none"
                onClick={() => handleSystemFilter(dsys.short)}
              >
                {dsys.fullName}
              </button>
            </li>
          ))}
        </ul>
      </li>
      {/* == PIPE category systems == */}
      <li className="dropdown-menu-item">
        <button
          type="button"
          className="text-left w-full focus:outline-none flex justify-between"
        >
          Pipe
          <ChevronRightIcon className="size-4 inline-block" />
        </button>
        {/* sub menu system list */}
        <ul className="dropdown-submenu dropdown-menu w-48">
          {pipeSystems.map((psys) => (
            <li
              key={psys.short}
              className="dropdown-menu-item"
              data-item={psys.short}
            >
              <button
                type="button"
                className="text-left w-full focus:outline-none"
                onClick={() => handleSystemFilter(psys.short)}
              >
                {psys.fullName}
              </button>
            </li>
          ))}
        </ul>
      </li>
    </ul>
  );
};
